import React from 'react';

import { Badge, Typography } from '@sravni/react-design-system';
import {
  Briefcase,
  CarAccident,
  CardTimer,
  Deposit,
  Exchange,
  House,
  Plane,
  PopularProfessions,
  PrizeCup,
  Wallet,
  WalletBag,
} from '@sravni/react-icons';

import { SERVICE_MENU } from '../../ServiceMenu/index_variantB';
import { IProductData, TYPES } from '../types/productBlock';

const { Heading } = Typography;

export const productCardsData: IProductData[] = [
  {
    key: TYPES.OSAGO,
    customStyle: {},
    title: <Heading level={6}>{'ОСАГО'}</Heading>,
    eventCategory: 'ОСАГО',
    subtitle: 'Поможем сэкономить до\u00A05\u00A0500\u00A0₽',
    badge: <Badge color="blue" variant="secondary" text="Розыгрыш авто" />,
    pageUrl: '/osago/',
    picture: [
      <source
        key={`source-product-${TYPES.OSAGO}-webp`}
        srcSet={require(`../../../public/images/promoBlocks/osago-promotion-mobile.webp`)}
        //media={`(min-width: ${styles.breakpointDesktop})`}
        type="image/webp"
      />,
      <img
        key={`img-product-${TYPES.OSAGO}`}
        srcSet={require(`../../../public/images/promoBlocks/osago-promotion-mobile.png`)}
        alt="osago"
      />,
    ],
  },
  {
    key: TYPES.CREDIT,
    customStyle: {},
    title: (
      <Heading level={6}>
        Подбор
        <br />
        кредита
      </Heading>
    ),
    eventCategory: 'Подбор кредита',
    subtitle: { mobile: null, desktop: 'Подберем банки, готовые выдать кредит' },
    icon: { mobile: <Wallet />, desktop: null },
    badge: null,
    pageUrl: '/kredity/onlajn-zayavka-na-kredit/',
    picture: [
      <source
        key={`source-product-${TYPES.CREDIT}-webp`}
        srcSet={require(`../images/credit_2x.webp`)}
        type="image/webp"
      />,
      <img key={`img-product-${TYPES.CREDIT}`} src={require(`../images/credit_2x.png`)} alt="credit" />,
    ],
  },
  {
    key: TYPES.KASKO,
    customStyle: {},
    title: 'КАСКО',
    eventCategory: 'КАСКО',
    subtitle: '',
    icon: <CarAccident />,
    pageUrl: '/kasko/',
  },
  {
    key: TYPES.LOANS,
    title: 'Займы',
    eventCategory: 'Микрокредиты',
    subtitle: '',
    badge: <Badge color="violet" variant="secondary" text="от 0%" />,
    icon: <WalletBag />,
    pageUrl: '/zaimy/',
  },
  {
    key: TYPES.MORTGAGE_INSURANCE,
    customStyle: {},
    title: (
      <Heading level={6}>
        Страхование
        <br />
        ипотеки
      </Heading>
    ),
    eventCategory: 'Страхование ипотеки',
    subtitle: '',
    icon: null,
    badge: null,
    pageUrl: '/strahovanie-ipoteki/',
    picture: [
      <source
        key={`source-product-${TYPES.MORTGAGE_INSURANCE}-webp`}
        srcSet={require(`../images/mortgageInsurance_2x.webp`)}
        type="image/webp"
      />,
      <img
        key={`img-product-${TYPES.MORTGAGE_INSURANCE}`}
        src={require(`../images/mortgageInsurance_2x.png`)}
        alt="credits rating"
      />,
    ],
  },
  {
    key: TYPES.CREDITS_RATING,
    title: (
      <Heading level={6}>
        Кредитный <br /> рейтинг
      </Heading>
    ),
    customStyle: {},
    eventCategory: 'Кредитный рейтинг',
    eventLabel: 'Банки',
    subtitle: '',
    icon: null,
    badge: null,
    pageUrl: '/kredity/scoring/',
    picture: [
      <source
        key={`source-product-${TYPES.CREDITS_RATING}-webp`}
        srcSet={require(`../images/creditsRating_2x.webp`)}
        type="image/webp"
      />,
      <img
        key={`img-product-${TYPES.CREDITS_RATING}`}
        src={require(`../images/creditsRating_2x.png`)}
        alt="credits rating"
      />,
    ],
  },
  {
    key: TYPES.DEPOSITS,
    title: 'Вклады',
    eventCategory: 'Вклады',
    subtitle: '',
    icon: <Deposit />,
    pageUrl: '/vklady/',
  },
  {
    key: TYPES.MORTGAGE,
    title: 'Ипотека',
    eventCategory: 'Ипотека',
    subtitle: '',
    icon: <House />,
    pageUrl:
      'https://www.cian.ru/ipoteka-main/?utm_source=sravni&utm_medium=cpa&utm_campaign=sravni_zayavka_online&utm_content=cian_ipoteka_from_zayavka_online&utm_term=ipoteka_08&sravni_id=%7Btransaction_id%7D&noreferrer=1',
  },
  {
    key: TYPES.VZR,
    title: 'Cтраховка для туриста',
    eventCategory: 'ВЗР',
    subtitle: '',
    icon: <Plane />,
    pageUrl: '/vzr/',
  },
  {
    key: TYPES.SPORT_INSURANCE,
    title: 'Страхование спортсменов',
    eventCategory: 'НС',
    subtitle: '',
    icon: <PrizeCup />,
    pageUrl: '/strahovanie-ns/',
  },
  {
    key: TYPES.CREDITS_CARDS,
    customStyle: {},
    title: 'Кредитные карты',
    eventCategory: 'Кредитные карты',
    subtitle: '',
    icon: <CardTimer />,
    pageUrl: '/karty/',
  },
  {
    key: TYPES.EDUCATION,
    customStyle: {},
    title: 'Онлайн курсы',
    eventCategory: 'Курсы',
    subtitle: '',
    icon: <PopularProfessions />,
    pageUrl: '/kursy/',
    cardColor: 'orange',
  },
  {
    key: TYPES.REFINANCING,
    customStyle: {},
    title: 'Рефинанси-рование',
    eventCategory: 'Рефинансирование кредитов',
    subtitle: '',
    icon: <Exchange />,
    pageUrl: '/kredity/refinansirovanie/',
  },
  {
    key: TYPES.BUSINESS,
    customStyle: {},
    title: 'Для бизнеса',
    eventCategory: 'Бизнес',
    subtitle: '',
    icon: <Briefcase />,
    pageUrl: '/biznes/',
    cardColor: 'violet',
  },
  {
    key: TYPES.SERVICE_MENU,
    customStyle: { minWidth: '80px' },
    title: (
      <Heading level={6}>
        Все <br />
        услуги
      </Heading>
    ),
    eventCategory: 'Все услуги',
    subtitle: '',
    icon: <Briefcase />,
    pageUrl: SERVICE_MENU,
    cardColor: 'blue',
  },
];
